import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ModalBaseComponent } from 'app/shared/components/base/modal-base/modal-base.component';
import { SmsMessage } from 'app/shared/models/sms-message.model';
import { SmsMessageService } from 'app/shared/services/sms-message.service';

@Component({
  selector: 'app-send-sms-message',
  templateUrl: './send-sms-message.component.html',
  styleUrls: ['./send-sms-message.component.scss']
})

export class SendSmsMessageComponent extends ModalBaseComponent implements OnInit {

  contentLength: number = 0;
  addedAndSendSuccessfullyMessage: string;

  constructor(public smsMessageService: SmsMessageService, protected activeModal: NgbActiveModal, protected translateService: TranslateService) {
    super(activeModal);
  }

  ngOnInit() {
    this.initializeObject();
  }

  initializeObject() {
    if (this.currentObject == null) {
      this.currentObject = new SmsMessage();
    }
    super.initializeObject();

    this.translateService.get(['sendSmsMessage.addedSuccessfullyMessage', 'sendSmsMessage.addedAndSendSuccessfullyMessage'])
      .subscribe(translations => {
        this.addedSuccessfullyMessage = translations['sendSmsMessage.addedSuccessfullyMessage'];
        this.addedAndSendSuccessfullyMessage = translations['sendSmsMessage.addedAndSendSuccessfullyMessage'];
      });
  }

  contentChanged() {
    this.contentLength = this.currentObject.Content.length;
  }

  onSubmit(form: NgForm) {
    if (!form.value.SmsMessageId) {
      this.smsMessageService.postSmsMessage(form.value, () => this.handleSubmit(form), this.addedSuccessfullyMessage, this.addedAndSendSuccessfullyMessage);
    }
  }
}
